import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router";
import { useT } from "src/i18n";

// Connected vertical timeline — the steps ARE a sequence (1→2→3), so they read
// as one connected flow (disc + rail line), deliberately distinct from the
// parallel benefits strip above. Single centered column at every breakpoint.
const STEP_GAP = "30px";
const DISC = 44;

export default function ProcessSection() {
    const t = useT();
    const STEPS = [
        { n: 1, title: t("landing.process.steps.step1.title"), body: t("landing.process.steps.step1.body") },
        { n: 2, title: t("landing.process.steps.step2.title"), body: t("landing.process.steps.step2.body") },
        { n: 3, title: t("landing.process.steps.step3.title"), body: t("landing.process.steps.step3.body") },
    ];
    return (
        <Card
            component="section"
            id="nain-se-toimii"
            sx={{ p: { xs: 3, md: 5 }, scrollMarginTop: { xs: 72, md: 88 } }}
        >
            <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                <Stack spacing={{ xs: 4, md: 5 }} sx={{ alignItems: "center" }}>
                    <Stack spacing={1} sx={{ alignItems: "center", textAlign: "center" }}>
                        <Typography
                            variant="h4"
                            component="h2"
                            sx={{ textTransform: "uppercase", letterSpacing: "0.04em" }}
                        >
                            {t("landing.process.heading")}
                        </Typography>
                        <Typography variant="body1" sx={{ color: "text.secondary" }}>
                            {t("landing.process.subheading")}
                        </Typography>
                    </Stack>

                    <Box sx={{ width: "100%", maxWidth: 480 }}>
                        {STEPS.map(({ n, title, body }, i) => {
                            const last = i === STEPS.length - 1;
                            return (
                                <Box key={n} sx={{ display: "flex", gap: 2.5, pb: last ? 0 : STEP_GAP }}>
                                    <Box sx={{ position: "relative", flexShrink: 0, width: DISC, display: "flex", justifyContent: "center" }}>
                                        {!last && (
                                            <Box
                                                aria-hidden
                                                sx={{
                                                    position: "absolute",
                                                    top: DISC,
                                                    bottom: `calc(-1 * ${STEP_GAP})`,
                                                    left: "50%",
                                                    width: "2px",
                                                    transform: "translateX(-50%)",
                                                    bgcolor: "divider",
                                                }}
                                            />
                                        )}
                                        <Box
                                            sx={{
                                                position: "relative",
                                                zIndex: 1,
                                                width: DISC,
                                                height: DISC,
                                                borderRadius: "50%",
                                                bgcolor: "primary.main",
                                                color: "primary.contrastText",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: 700,
                                                fontSize: 18,
                                            }}
                                        >
                                            {n}
                                        </Box>
                                    </Box>
                                    <Box sx={{ pt: 0.5 }}>
                                        <Typography variant="subtitle1" component="h3" sx={{ fontWeight: 700, lineHeight: 1.25 }}>
                                            {title}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
                                            {body}
                                        </Typography>
                                    </Box>
                                </Box>
                            );
                        })}
                    </Box>

                    <Button
                        size="large"
                        variant="contained"
                        color="warning"
                        component={RouterLink}
                        to="/tilaa"
                        sx={{ px: 5, py: 1.5, fontSize: "1.1rem" }}
                    >
                        {t("common.nav.requestQuoteCta")}
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
}
